import React from 'react'
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function FairPlayPolicy() {
  return (
    <>
      <HomeNavbar />

      <div className="bg-white w-full py-20 text-center font-oswald mt-10">
        <div className="flex items-center justify-center">
          <p
            style={{ backgroundColor: "#F5A623" }}
            className="rounded-full py-2 px-6 font-bold text-bgBlue"
          >
            F&P
          </p>
        </div>

        <br />

        <h2 className="text-3xl font-bold text-gray-900">
         FairPlay <span className="text-secondary">Policy</span>
        </h2>

        <div className="lg:w-3/4 m-auto shadow-xl mt-10">
          <div className="text-bgBlue p-8 text-start">

            <h1 className="text-4xl font-bold mb-4">FairPlay Policy</h1>
            <p className="mb-4">Effective Date: 30 November 2025</p>
            <p className="mb-4">Platform Name: Adhyayi</p>
            <p className="mb-4">Owned & Operated By: AKRYPT IT SOLUTIONS PRIVATE LIMITED</p>
            <p className="mb-4">Jurisdiction: India</p>

            {/* 1 */}
            <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    PURPOSE OF THIS POLICY
  </h2>

  <p>
    Adhyayi is a skill-based educational platform designed to provide
    learners with a transparent, fair, secure, and performance-driven
    learning environment.
  </p>

  <p className="mt-2">
    The purpose of this Fair Play & Anti-Fraud Policy is to:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Ensure fair competition among all users.</li>
    <li>Prevent cheating, fraud, manipulation, abuse, and misuse of the platform.</li>
    <li>Maintain trust, transparency, and integrity within quizzes, contests, rewards, and rankings.</li>
    <li>Clearly distinguish the platform from gambling, betting, wagering, lottery, or chance-based gaming.</li>
    <li>Support compliance with applicable Indian laws and regulations.</li>
  </ul>
</section>

            {/* 2 */}
           <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    NATURE OF THE PLATFORM (LEGAL CLARIFICATION)
  </h2>

  <p>
    Adhyayi is a skill-based educational and assessment platform.
  </p>
   <p>The platform:</p>

  <ul className="list-disc ml-6 mt-2">
    <li>Operates on user knowledge, preparation, learning outcomes, and performance.</li>
    <li>Provides educational quizzes, mock tests, contests, rankings, learning tools, and performance-based rewards.</li>
    <li>Is not a gambling platform.</li>
    <li>Is not a betting platform.</li>
    <li>Does not facilitate wagering activities.</li>
    <li>Does not conduct lotteries, lucky draws, or games of chance.</li>
    <li>Does not determine outcomes through randomness or luck.</li>
  </ul>

  <p className="mt-3">
    All scores, rankings, rewards, and contest outcomes are based on
    knowledge, accuracy, speed, consistency, and contest-specific
    performance criteria.
  </p>
  <p className="mt-3">
    Accordingly, Adhyayi operates within the framework of skill-based activities recognized under Indian legal principles relating to skill-based competitions.
  </p>
</section>

            {/* 3 */}
           <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    FAIR PLAY PRINCIPLES
  </h2>
  <p className='mt-3'>Adhyayi follows the following core fair-play principles:</p>

  <ul className="list-disc ml-6 mt-3">
    <li>Equal rules for all users.</li>
    <li>Uniform scoring methodology.</li>
    <li>Equal contest conditions and evaluation criteria.</li>
    <li>Performance-based assessment only.</li>
    <li>Automated result generation and scoring mechanisms.</li>
    <li>Time-bound quizzes and contests.</li>
    <li>Transparent ranking methodologies.</li>
  </ul>

  <p className="mt-3">
    No user shall receive :
      </p>
  <ul className="list-disc ml-6 mt-3">
    <li>special privileges,</li>
    <li>manual score enhancement,</li>
    <li> preferential treatment,</li>
    <li>backdoor access,</li>
    <li>unfair competitive advantages.</li>
  </ul>
  <p className="mt-3">
  The platform is committed to maintaining a level playing field for all participants.

  </p>
</section>

            {/* 4 */}
          <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    QUESTION & CONTEST INTEGRITY
  </h2>

  <p className='mt-3'>Adhyayi maintains strict standards regarding contest and quiz integrity.</p>

  <p className="font-semibold mt-3">Question Management</p>

  <ul className="list-disc ml-6">
    <li>Questions are curated, reviewed, and verified before publication.</li>
    <li>Managed by authorized content and administrative teams.</li>
    <li>Prepared for educational relevance, syllabus alignment, and accuracy.</li>
  </ul>

  <p className="font-semibold mt-4">Contest Integrity</p>

  <ul className="list-disc ml-6">
    <li>Contest submissions are evaluated through automated systems.</li>
    <li>User answers and scores cannot be manually altered after submission.</li>
    <li>Every contest operates within a predefined time duration.</li>
    <li>Scoring and ranking are generated through system-based logic.</li>
  </ul>

  <p className="font-semibold mt-4">Important Legal Clarification</p>

  <p>
    Questions may be known to the platform administrators before publication because they are responsible for creating, reviewing, and uploading educational content.
  </p>
  <p className='mt-3'>However :</p>

  <ul className="list-disc ml-6 mt-3">
    <li>Contest outcomes cannot be manually manipulated.</li>
    <li>Scores cannot be manually adjusted to favor any participant.</li>
    <li>Rankings cannot be manually modified to influence winners.</li>
    <li>Reward distribution cannot be altered for unfair advantage.</li>
  </ul>
</section>
  <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    Contest Ranking Methodology
  </h2>

  <p>
   Contest rankings may be determined using one or more of the following factors:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Score Achieved</li>
    <li>Accuracy Percentage</li>
    <li>Time Taken</li>
    <li>Submission Time</li>
    <li>Contest-Specific Rules</li>
  </ul>

  <p className="mt-3">
    The applicable ranking methodology may vary depending on the contest format, educational objective, or assessment structure.
  </p>
</section>

            {/* 5 */}
           <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    RESULT TRANSPARENCY & PERFORMANCE VERIFICATION
  </h2>

  <p className='mt-3'>
   To promote transparency and user confidence, Adhyayi provides system-generated performance records.
  </p>
  <p className='mt-3'>
Upon contest submission, users may receive an automatically generated scorecard that serves as provisional performance evidence.
  </p>
  <p className='mt-3'>
Such scorecards may include:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Total Questions</li>
    <li>Attempted Questions</li>
    <li>Correct Answers</li>
    <li>Incorrect Answers</li>
    <li>Skipped Questions</li>
    <li>Accuracy Percentage</li>
    <li>Time Taken</li>
    <li>System Timestamp</li>
    <li>Other relevant performance metrics</li>
  </ul>

  <p className='mt-3'>Following submission:</p>
 <ul className="list-disc ml-6 mt-2">
    <li>Responses are locked.</li>
    <li>User submissions become non-editable.</li>
    <li>Performance records are preserved within the system.</li>
  </ul>
  <p className="mt-3">
   Official leaderboards, rankings, and reward allocations may be published after the contest officially concludes.
  </p>
  <p className="mt-3">
This process helps ensure:  </p>
<ul className="list-disc ml-6 mt-2">
    <li>Transparency,</li>
    <li>Fair competition,</li>
    <li>Auditability,</li>
    <li>Prevention of post-submission tampering.</li>
  </ul>

</section>

            {/* 6 */}
           <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    COINS, REWARDS & WALLET SYSTEM
  </h2>

  <p>
    Adhyayi may use Coins, Reward Points, Credits, Wallet Balances, or similar virtual reward units within the platform.
  </p>
  <p>
Users acknowledge and agree that such virtual units:  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Not legal tender.</li>
    <li>Not currency.</li>
    <li>Not cryptocurrency.</li>
    <li>Not securities.</li>
    <li>Not investment products.</li>
    <li>Do not represent ownership rights.</li>
    <li>Have no independent monetary value outside the platform.</li>
  </ul>
  <p className='mt-3'>
Such virtual units:  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Cannot be transferred between users unless explicitly permitted by the platform.</li>
    <li>Cannot be sold, traded, assigned, or exchanged outside the platform.</li>
    <li>Cannot be sold, traded, assigned, or exchanged outside the platform.</li>
  </ul>
  <p className='mt-3'>
Permitted uses may include:  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Contest participation,</li>
    <li>Reward redemption,</li>
    <li>Educational benefits,</li>
    <li>Platform features,</li>
    <li>Eligible withdrawals where permitted under applicable rules and policies.</li>
  </ul>
</section>

            {/* 7 */}
         <section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-4">
    <span className="text-secondary text-5xl mr-2">•</span>
    PROHIBITED ACTIVITIES
  </h2>

  <p className="mb-4">
    The following activities are strictly prohibited:
  </p>

  <div className="mb-5">
    <h3 className="font-semibold text-lg mb-2">
      A. AI-Assisted Manipulation
    </h3>


<p className="mb-2">Users shall not:</p>

<ul className="list-disc ml-6">
  <li>
    Use artificial intelligence tools to unfairly influence contest outcomes.
  </li>
  <li>
    Use automated answer-generation systems during active contests.
  </li>
  <li>
    Use bots, scripts, macros, automation software, or similar technologies
    to manipulate rankings, scores, rewards, or participation metrics.
  </li>
</ul>


  </div>

  <div className="mb-5">
    <h3 className="font-semibold text-lg mb-2">
      B. Unfair External Assistance
    </h3>


<p className="mb-2">Users shall not:</p>

<ul className="list-disc ml-6">
  <li>Obtain unauthorized assistance during contests.</li>
  <li>Coordinate answers with other participants.</li>
  <li>
    Use unfair methods intended to influence contest outcomes.
  </li>
</ul>


  </div>

  <div className="mb-5">
    <h3 className="font-semibold text-lg mb-2">
      C. Account-Related Fraud
    </h3>


<p className="mb-2">Including but not limited to:</p>

<ul className="list-disc ml-6">
  <li>Creating multiple accounts.</li>
  <li>Using false, misleading, or fraudulent information.</li>
  <li>Impersonating another person.</li>
  <li>Accessing another user's account.</li>
</ul>


  </div>

  <div className="mb-5">
    <h3 className="font-semibold text-lg mb-2">
      D. Quiz & Contest Fraud
    </h3>


<p className="mb-2">Including but not limited to:</p>

<ul className="list-disc ml-6">
  <li>Question leaks.</li>
  <li>Answer sharing.</li>
  <li>Collusion.</li>
  <li>Coordinated participation schemes.</li>
  <li>Organized cheating activities.</li>
</ul>


  </div>

  <div className="mb-5">
    <h3 className="font-semibold text-lg mb-2">
      E. Technical Abuse
    </h3>


<p className="mb-2">Including but not limited to:</p>

<ul className="list-disc ml-6">
  <li>Exploiting software bugs.</li>
  <li>Exploiting vulnerabilities.</li>
  <li>Reverse engineering.</li>
  <li>Unauthorized system access.</li>
  <li>Hacking attempts.</li>
  <li>Security bypass attempts.</li>
</ul>


  </div>

  <div>
    <h3 className="font-semibold text-lg mb-2">
      F. Payment & Reward Abuse
    </h3>


<p className="mb-2">Including but not limited to:</p>

<ul className="list-disc ml-6">
  <li>False recharge claims.</li>
  <li>Fraudulent withdrawal requests.</li>
  <li>Referral abuse.</li>
  <li>Self-referral schemes.</li>
  <li>Manipulation of reward systems.</li>
</ul>


  </div>
</section>

          {/* 8 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    MONITORING, DETECTION & INVESTIGATION
  </h2>

  <p className="mb-3">
    To protect platform integrity, Adhyayi may implement various monitoring
    and fraud-detection mechanisms, including:
  </p>

  <ul className="list-disc ml-6">
    <li>Device identification and tracking.</li>
    <li>IP address monitoring.</li>
    <li>Activity pattern analysis.</li>
    <li>Contest timing analysis.</li>
    <li>Response behavior analysis.</li>
    <li>Leaderboard anomaly detection.</li>
    <li>Device fingerprinting (where technically feasible).</li>
    <li>Automated fraud detection systems.</li>
    <li>Manual compliance reviews.</li>
  </ul>

  <p className="font-semibold mt-4">
    If suspicious activity is detected, Adhyayi may:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Temporarily restrict account access.</li>
    <li>Hold rewards, coins, credits, or withdrawals.</li>
    <li>Conduct investigations.</li>
    <li>Request additional verification.</li>
    <li>Suspend participation privileges.</li>
  </ul>

  <p className="font-semibold mt-4">
    No Guarantee of a Completely Cheating-Free Environment
  </p>

  <p className="mt-2">
    While Adhyayi employs multiple fairness mechanisms, including timers,
    randomized question delivery, randomized answer options, scoring
    algorithms, activity monitoring, and fraud detection systems, no online
    platform can guarantee the complete elimination of unfair conduct.
  </p>

  <p className="mt-2">
    Users acknowledge and accept that absolute prevention of all cheating,
    fraud, or misconduct may not always be possible.
  </p>
</section>

{/* 9 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    ACTIONS AGAINST POLICY VIOLATIONS
  </h2>

  <p className="mb-3">
    Where violations are detected or reasonably suspected, Adhyayi may take
    one or more of the following actions:
  </p>

  <ul className="list-disc ml-6">
    <li>Issue warnings.</li>
    <li>Temporarily suspend accounts.</li>
    <li>Permanently terminate accounts.</li>
    <li>Cancel contest participation.</li>
    <li>Remove rankings.</li>
    <li>Forfeit rewards, coins, credits, or benefits.</li>
    <li>Restrict withdrawals.</li>
    <li>Block future participation.</li>
    <li>Initiate legal proceedings where appropriate.</li>
  </ul>

  <p className="mt-3">
    The platform's decision regarding enforcement actions shall be final and
    binding to the extent permitted by applicable law.
  </p>
</section>

{/* 10 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    ADMINISTRATIVE AUTHORITY & RESPONSIBILITIES
  </h2>

  <p className="mb-3">
    Platform administrators are responsible for:
  </p>

  <ul className="list-disc ml-6">
    <li>Maintaining question quality.</li>
    <li>Managing educational content.</li>
    <li>Defining contest structures and rules.</li>
    <li>Preventing fraud and abuse.</li>
    <li>Ensuring platform integrity.</li>
  </ul>

  <p className="font-semibold mt-4">
    Administrators shall not:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Manually alter scores.</li>
    <li>Manipulate rankings.</li>
    <li>Provide unfair advantages.</li>
    <li>Influence contest outcomes.</li>
    <li>Favor specific participants.</li>
  </ul>

  <p className="mt-3">
    Administrative authority exists solely to manage platform operations
    and maintain fairness.
  </p>
</section>

{/* 11 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    LEGAL COMPLIANCE
  </h2>

  <p className="mb-3">
    Adhyayi seeks to operate in compliance with applicable Indian laws,
    including but not limited to:
  </p>

  <ul className="list-disc ml-6">
    <li>Information Technology Act, 2000</li>
    <li>Indian Contract Act, 1872</li>
    <li>Consumer Protection Act, 2019</li>
    <li>Applicable Digital and Data Protection Regulations</li>
    <li>Applicable State-Specific Laws</li>
    <li>Judicial principles relating to skill-based competitions</li>
  </ul>

  <p className="mt-3">
    The platform is intended to function as a skill-based educational
    platform and not as a chance-based gaming service.
  </p>
</section>

{/* 12 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    USER RESPONSIBILITIES
  </h2>

  <p className="mb-3">
    By using Adhyayi, users agree that they shall:
  </p>

  <ul className="list-disc ml-6">
    <li>Use the platform fairly and responsibly.</li>
    <li>Follow all applicable rules, policies, and guidelines.</li>
    <li>Maintain accurate account information.</li>
    <li>Avoid cheating, fraud, or misuse.</li>
    <li>Cooperate with investigations when required.</li>
  </ul>

  <p className="mt-3">
    Violation of these obligations may result in suspension, termination,
    or other enforcement actions.
  </p>
</section>

{/* 13 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    POLICY UPDATES
  </h2>

  <p>
    Adhyayi reserves the right to amend, modify, update, replace, or revise
    this Policy at any time.
  </p>

  <p className="mt-2">
    Updated versions shall become effective upon publication on the website,
    application, or other official platform channels.
  </p>

  <p className="mt-2">
    Continued use of Adhyayi after such publication constitutes acceptance
    of the revised Policy.
  </p>
</section>

{/* 14 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    CONTACT INFORMATION
  </h2>

  <p>
    For Fair Play, Fraud Prevention, Compliance, or Policy-related inquiries:
  </p>

  <p className="mt-2">
    Email:
    <a
      href="mailto:support@adhyayi.com"
      className="text-blue-500 underline ml-1"
    >
      support@adhyayi.com
    </a>
  </p>
</section>

{/* 15 */}

<section>
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    FINAL LEGAL NOTICE
  </h2>

  <p>
    Adhyayi is committed to promoting fair learning, transparent competition,
    educational excellence, and performance-based rewards.
  </p>

  <p className="mt-2">
    Every participant is expected to compete honestly, act responsibly,
    and uphold the principles of integrity and fair play.
  </p>

  <p className="mt-2">
    Success on the platform is determined by skill, knowledge,
    preparation, accuracy, consistency, and performance—not by chance.
  </p>
</section>


          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default FairPlayPolicy;